import './index.css';
import { make } from '../../../utils';

import Header from '@editorjs/header';

export default class CustomHeader extends Header {

  static get sanitize() {
	return {
	  span: {
		id: true,
		contenteditable: true,
		class: true
	  }
	};
  }

  getTag() {
    let tag = document.createElement(this.currentLevel.tag);

    tag = make(this.currentLevel.tag, [this._CSS.block, this._CSS.wrapper], {})
   
    tag.innerHTML = this._data.text || '';
    tag.contentEditable = this.readOnly ? 'false' : 'true';
    tag.dataset.placeholder = this.api.i18n.t(this._settings.placeholder || '');

    return tag;
  }
}